var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8875 170.006L22.8438 12.5H177.156L163.094 169.981L99.9062 187.5L36.8875 170.006Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 174.112L151.062 159.956L163.075 25.3812H100V174.112Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83.7937H74.4375L72.675 64.0125H100V44.6937H51.5625L52.025 49.8812L56.7688 103.112H100V83.7937ZM100 133.962L99.9125 133.987L78.4 128.181L77.025 112.775H57.6312L60.3375 143.1L99.9125 154.087L100 154.062V133.962Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9312 83.7937V103.112H123.719L121.481 128.169L99.9312 133.981V154.081L139.537 143.1L139.825 139.837L144.362 88.9812L144.837 83.7937H99.9312ZM99.9312 44.6937V64.0125H146.594L146.981 59.675L147.862 49.8812L148.325 44.6937H99.9312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.0440e72ba2861c972f5236ef496e5fd1.svg";
export { ForwardRef as ReactComponent };